<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper" style="background-color: #FFF;">
      <mentee-sidebar-menu v-if="checkIsMentee()  || ($store.state.switch_flag == 'Mentee')" :show_menu="true" :show_back_button="false" />
      <ManagerSidebarMenu v-if="checkIsManager() || ($store.state.switch_flag == 'Manager' && !entepriseAdmin)" :show_menu="true" :show_back_button="false" back_link="managerReports"></ManagerSidebarMenu>
      <MentorSidebarMenu v-if="checkIsMentor()  || ($store.state.switch_flag == 'Mentor')" :show_menu="true" :show_back_button="false" back_link="mentorReports"></MentorSidebarMenu>
      <EnterprieSidebarMenu v-if="checkIsEnterprise() || this.$store.state.switch_admin_enterprise_flag == 1" :show_menu="true" :show_back_button="false" back_link="managerReports"></EnterprieSidebarMenu>

      <div class="content-wrapper" style="background-color: #FFF; padding-left: 165px; ">
        <div class="container-wrapper center">
          <div style="text-align: center;">
            <flash-message autoHide variant="success"></flash-message>
          </div>
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
            >
            {{ success_message }}
          </b-alert>
          <div class="row">
            <div>
              <h3 class="heading text-uppercase mb-3" style="padding-left: 10px;">My Profile</h3>
            </div>
          </div>
          <div v-if="action == 'view-profile'">
            <div class="row">
              <div class="col-6 pr-3 pr-xl-5">
                <div class="shadow rounded px-3 py-3">
                  <div class="row align-items-end">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                          <div class="h6 mb-0 font-weight-bold" style="padding-bottom: 20px;">Information</div>
                        </div>
                        <div class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right">
                          <a @click="openEditProfileForm()" class="btn btn-primary btn-sm dbEditBtn branding_text_color">Edit</a>
                        </div>
                      </div>
                      <div class="personal-details-wrapper">
                        <div class="row grid_row">
                          <div class="col-4">
                            <div class="label_txt">Name: </div>
                          </div>
                          <div class="col-8 text-right">
                            <div class="label_txt">{{ first_name + ' ' + last_name }} </div>
                          </div>
                        </div>
                        <div class="row grid_row">
                          <div class="col-4 ">
                            <div class="label_txt">Email Address: </div>
                          </div>
                          <div class="col-8 text-right">
                            <div class="label_txt">{{ truncate(email) }}</div>
                          </div>
                        </div>
                        <div class="row grid_row" v-if="phone_number != ''">
                          <div class="col-4">
                            <div class="label_txt">Phone Number: </div>
                          </div>
                          <div class="col-8 text-right">
                            <div class="label_txt">{{ phone_number }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="clear: both; margin-bottom: 20px;" ></div>
                <div class="shadow rounded px-3 py-3" v-show="isUser()">
                  <div class="row align-items-end">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                          <div class="h6 mb-0 font-weight-bold" style="padding-bottom: 20px;">Change Password</div>
                        </div>
                        <div class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right">
                          <a @click="openCPAuthModal()" class="btn btn-primary btn-sm dbEditBtn branding_text_color">Edit</a>
                        </div>
                      </div>
                      <div class="personal-details-wrapper">
                        <div class="row grid_row">
                          <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                            <div class="label_txt">Password</div>
                        </div>
                        <div class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right">
                          ********
                        </div>
                      </div>
                      <div class="row grid_row">
                        <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                          <div class="label_txt">Enable Multifactor Authentication</div>
                        </div>
                        <div class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right">
                          <label class="switch" style="margin-left: 10px; padding: 0;">
                            <input type="checkbox" v-model="multifactor_authentication" @change="openAuthModal($event)" :checked="multifactor_authentication">
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="clear: both; margin-bottom: 15px;" ></div>
              <div class="shadow rounded px-3 py-3" v-show="isUser() && !entepriseAdmin && !researcher && !csr">
                <div class="row align-items-end">
                  <div class="col-12">
                    <div class="row">
                        <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                          <div class="h6 mb-0 font-weight-bold" style="padding-bottom: 20px;">Security & Preferences</div>
                        </div>
                        <div class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right">
                        </div>
                      </div>
                      <div class="col-12 p-0" >
                        <div class="" >
                          <div class="db-report-card" >
                            <div class="row">
                              <div class="col-11 db_name_block">
                                <div class="db-mentee-name">
                                  Communication
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols" style="padding-left: 40px; padding-bottom: 5px;">
                                <div class="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    v-bind:id="news_subscription"
                                    v-bind:name="news_subscription"
                                    ref="news_subscription"
                                    v-model="news_subscription_selected"
                                    :checked="news_subscription_checked" @click="changeUserNewsSubscribe($event)" class="custom-control-input" 
                                    :value="1" style="margin-top: 4px; height: 12px;"
                                    >
                                  <label class="custom-control-label" for="news_subscription" style="font-size: 14px;">News, updates, promotions & more!</label>
                                </div>  
                                </div>
                                <div class="db-mentee-name">
                                  Frequency
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols" style="padding-left: 20px; padding-bottom: 0px;">
                                  <div class="custom-control " >
                                    <div class="col-5 p-0 float-left">
                                    <label for="notification"  style="padding-top:2px;" class="preference-heading">Mentoring support communication</label>
                                    </div>
                                    <div class="search-padd float-left col-7">
                                      <select 
                                      class="custom-select" 
                                      id="frequency" 
                                      name="frequency" 
                                       v-model="frequency" @change="changeUserFrequency()"
                                      >
                                      <option v-for="(item, index) in frequency_options" :key="index" :value="item.value">{{ item.text }}</option>
                                      </select>
                                    </div>
                                    <div style="clear: both;"></div>
                                  </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols" style="padding-left: 45px; padding-bottom: 5px;">
                                  <label for="notification"  style="padding-top:0px; font-size: 11px; font-style: italic; color: #B1B8BA;" class="preference-heading">A successful mentoring program is based on consistent communication Mentor Mentee recommends your communication frequency remain on default.</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="clear: both; margin-bottom: 20px;" ></div>  
              </div>
              <div class="col-6 pr-3 pr-xl-5">
              </div>
            </div>
            <div style="clear: both; margin-bottom: 20px;" ></div>
          </div>
        </div>  
      </div>
    </div>  
  <EditProfile
    :isModalVisible="isEditProfileModalVisible"
    ref="edit_profile_form"
    @close="isEditProfileModalVisible = false">
  </EditProfile>
  <UpdatePassword
    :isModalVisible="isUpdatePasswordModalVisible"
    ref="update_password_form"
    @close="isUpdatePasswordModalVisible = false">
  </UpdatePassword>

    <PreferenceUpdateConfirmModal :isModalVisible="isPrefereceUpdateConfirmModalVisible"  @close="closeConfirm()">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading" style="margin-left: 0;">{{ modal_title }}</div>
      <div slot="body">
        <span v-html="modal_message"></span>
      </div>
      <div slot="footer" class="col-12 p-0">
        <div class="col-6 float-left p-0">
          <button class="btn btn-sm closeBtn" @click="closeConfirm()">Cancel</button>
        </div>
        <div class="col-6 float-left p-0 text-align-right">
          <button v-if="buttonTitle == 'Update'" class="btn btn-sm ma-blue-btn" @click="onFrequencySubmit()">{{ buttonTitle }}</button>
          <button v-else class="btn btn-sm ma-blue-btn" @click="onSubscribeNewsSubmit()">{{ buttonTitle }}</button>
        </div>
        <div style="clear: both;"></div>
      </div>
    </PreferenceUpdateConfirmModal>

    <SuccessConfirmModal :isModalVisible="isSuccessConfirmModalVisible"  @close="closeSuccessConfirm()">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading" style="margin-left: 0;">{{ modal_success_title }}</div>
      <div slot="body">
        <span v-html="modal_success_message"></span>
      </div>
      <div slot="footer" class="col-12 p-0">
        <div class="col-12 text-center">
          <button class="btn btn-sm ma-blue-btn" @click="closeSuccessConfirm()">Close</button>
        </div>
        <div style="clear: both;"></div>
      </div>
    </SuccessConfirmModal>


    <MultifactorAuthenticationConfirmModal :isModalVisible="isMultifactorAuthenticationConfirmModal"  @close="closeAuthConfirm()">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading" style="margin-left: -15px;">Enabling Multifactor Authentication</div>
      <div slot="body">
          <b-alert
            :show="dismissAuthCountDown"
            dismissible
            variant="success"
            @dismissed="dismissAuthCountDown=0"
            @dismiss-count-down="countDownAuthChanged"
            >
            {{ success_auth_message }}
          </b-alert>
          <b-alert
            :show="dismissCountWarningDown"
            dismissible
            variant="danger"
            @dismissed="dismissCountWarningDown=0"
            @dismiss-count-down="countDownWarningChanged"
            >
            {{ warning_message }}
          </b-alert>
          <div class="col-12" style="font-size: 13px; padding-bottom: 5px; margin-left: -33px;">
              Please enter the 6 digit code sent to your email.
          </div>
          <div class="col-12" style="margin-left: -8px">
              <SimpleOtpInput 
                v-model="auth_code"
                :inputProps="{
                  type: 'number',
                  min: 0,
                }" 
                @change="handleChange"/>


          </div>
          <div class="col-7 text-center branding_text_color" style="margin: 0px auto; margin-top: 20px; cursor: pointer;" @click="resendCode()">
              Did not receive a code?
          </div>
        
      </div>
      <div slot="footer" class="col-12 p-0">
        <div class="col-6 float-left p-0">
          <button class="btn btn-sm closeBtn" @click="closeAuthConfirm()" style="margin-left: -15px;">Cancel</button>
        </div>
        <div class="col-6 float-left p-0 text-align-right">
          <button class="btn btn-sm ma-blue-btn" :disabled="disable_verify_btn" :class="disable_verify_btn ? 'btn-blue-disabled' : 'btn-blue'" @click="verifyCode()" style="margin-right: -23px;">Enable</button>
        </div>
        <div style="clear: both;"></div>
      </div>
    </MultifactorAuthenticationConfirmModal>


    <ChangePasswordConfirmModal :isModalVisible="isChangePasswordConfirmModal"  @close="closeCPAuthConfirm()">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading" style="margin-left: -15px;">Change Password Authenication</div>
      <div slot="body">
          <b-alert
            :show="dismissCPAuthCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCPAuthCountDown=0"
            @dismiss-count-down="countDownCPAuthChanged"
            >
            {{ success_cp_auth_message }}
          </b-alert>
          <b-alert
            :show="dismissCountCPWarningDown"
            dismissible
            variant="danger"
            @dismissed="dismissCountCPWarningDown=0"
            @dismiss-count-down="countDownCPWarningChanged"
            >
            {{ warning_cp_message }}
          </b-alert>
          <div class="col-12" style="font-size: 13px; padding-bottom: 5px; margin-left: -33px;">
              Please enter the 6 digit code sent to your email.
          </div>
          <div class="col-12" style="margin-left: -8px">
              <SimpleOtpInput 
                v-model="cp_auth_code"
                :inputProps="{
                  type: 'number',
                  min: 0,
                }" 
                @change="handleCPChange"/>


          </div>
          <div class="col-7 text-center branding_text_color" style="margin: 0px auto; margin-top: 20px; cursor: pointer;" @click="resendCPCode()">
              Did not receive a code?
          </div>
        
      </div>
      <div slot="footer" class="col-12 p-0">
        <div class="col-6 float-left p-0">
          <button class="btn btn-sm closeBtn" @click="closeCPAuthConfirm()" style="margin-left: -15px;">Cancel</button>
        </div>
        <div class="col-6 float-left p-0 text-align-right">
          <button class="btn btn-sm ma-blue-btn" :disabled="disable_cp_verify_btn" :class="disable_cp_verify_btn ? 'btn-blue-disabled' : 'btn-blue'" @click="verifyCPCode()" style="margin-right: -23px;">Verify</button>
        </div>
        <div style="clear: both;"></div>
      </div>
    </ChangePasswordConfirmModal>

  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../router/index.js';
import { store } from '../store/store';
import UserMenu from './shared/user_menu.vue';
import MasteradminSidebarMenu from './shared/masteradmin_sidebar_menu.vue';
import {ValidationMethods} from './shared/common_validations.js';
import EditProfile from './edit_profile.vue';
import UpdatePassword from './update_password.vue';
import PreferenceUpdateConfirmModal from './admin/preference_confirm_modal.vue';
import MultifactorAuthenticationConfirmModal from './admin/preference_confirm_modal.vue';
import ChangePasswordConfirmModal from './admin/preference_confirm_modal.vue';
import SuccessConfirmModal from './admin/preference_confirm_modal.vue';
import MenteeSidebarMenu from '@/components/shared/mentee_sidebar_menu.vue';
import ManagerSidebarMenu from '@/components/shared/manager_sidebar_menu.vue';
import MentorSidebarMenu from '@/components/shared/mentor_sidebar_menu.vue';
import { checkIsManager, checkIsMentor, checkIsMentee, checkIsEnterprise } from '@/components/shared/utils.js';
import SimpleOtpInput from "vue-simple-otp-input";
import 'vue-simple-otp-input/dist/vue-simple-otp-input.css';
import EnterprieSidebarMenu from '@/components/shared/enterpriseadmin_sidebar_menu.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  mixins: [ValidationMethods],
  data() {
   return {
      action: 'view-profile',
      first_name: '',
      last_name: '',
      phone_number: '',
      email: '',
      roles: [],
      groups: [],
      password: '',
      confirm_password: '',
      loading: false,
      notification_phone: false,
      masterAdmin: false,
      admin: false,
      is_mentee: 0,
      isEditProfileModalVisible: false,
      isUpdatePasswordModalVisible: false,
      entepriseAdmin: false,
      researcher: false,
      csr: false,
      news_subscription: 'news_subscription',
      news_subscription_selected: false,
      news_subscription_checked: 0,
      frequency: 'Daily',
      frequency_options: [
        {value: '', text: 'Select Frequency'},
        {value: 'Daily', text: 'Daily (Default)'},
        {value: 'Tuesdays', text: 'Tuesdays'},
        {value: 'Wednesdays', text: 'Wednesdays'},
        {value: 'Thursdays', text: 'Thursdays'},
      ],
      isPrefereceUpdateConfirmModalVisible: false,
      isSuccessConfirmModalVisible: false,
      buttonTitle: '',
      modal_title: '',
      modal_message: '',
      modal_success_title: '',
      modal_success_message: '',
      oldNewsSubscribe: '',
      oldFrequency: '',    
      success_message: '',
      dismissCountDown: 0,      
      multifactor_authentication: false,
      isMultifactorAuthenticationConfirmModal: false,
      auth_code: '',
      dismissCountWarningDown: 0,
      warning_message: '',
      success_auth_message: '',
      dismissAuthCountDown: 0,
      disable_verify_btn: true,
      isChangePasswordConfirmModal: false,
      cp_auth_code: '',
      dismissCountCPWarningDown: 0,
      warning_cp_message: '',
      success_cp_auth_message: '',
      dismissCPAuthCountDown: 0,
      disable_cp_verify_btn: true,
    }
  },
  components: {
    SimpleOtpInput,
    UserMenu,
    MenteeSidebarMenu,
    MasteradminSidebarMenu,
    EditProfile,
    UpdatePassword,
    PreferenceUpdateConfirmModal,
    SuccessConfirmModal,
    ManagerSidebarMenu,
    MentorSidebarMenu,
    MultifactorAuthenticationConfirmModal,
    ChangePasswordConfirmModal,
    EnterprieSidebarMenu,
  },
  methods: {
    handleChange(v) {
      if(v.trim().length == 6) {
        this.disable_verify_btn = false;
      } else {
        this.disable_verify_btn = true;
      }
    },
    handleCPChange(v) {
      if(v.trim().length == 6) {
        this.disable_cp_verify_btn = false;
      } else {
        this.disable_cp_verify_btn = true;
      }
    },
    countDownCPWarningChanged(dismissCountCPWarningDown) {
      this.dismissCountCPWarningDown = dismissCountCPWarningDown
    },
    countDownCPAuthChanged(dismissCPAuthCountDown) {
      this.dismissCPAuthCountDown = dismissCPAuthCountDown;
    },
    resendCPCode() {
      axios('/generate-myprofile-cp-auth-code',
      {
          method: 'GET', 
      })
      .then(response => {                
          this.success_cp_auth_message = 'Code resend successfully.';
          this.dismissCPAuthCountDown = 5;
      })
      .catch(error => {

      });
    },
    verifyCPCode() {
      if(this.cp_auth_code == '') {
        alert("Please enter the verification code");
        return false;
      }
      else if(this.cp_auth_code.length != 6) {
        alert("Verification code should be 6 digit");
        return false;
      }
      else {
        this.disable_cp_verify_btn = true;
        axios('/verify-myprofile-cp-auth-code',
        {
            method: 'POST',
            data: {
              code: this.cp_auth_code,
            }
        })
        .then(response => {  
            this.isChangePasswordConfirmModal = false;
            this.isUpdatePasswordModalVisible = true;
        })
        .catch(error => {
          this.warning_cp_message = 'Invalid verification code.';
          this.dismissCountCPWarningDown = 5;
          this.cp_auth_code = '';
        });
      }

    },
    closeCPAuthConfirm() {
      this.isChangePasswordConfirmModal = false;
      this.isUpdatePasswordModalVisible = false;
      this.$emit('close');
    },
    openCPAuthModal() {
      axios('/generate-myprofile-cp-auth-code',
      {
          method: 'GET', 
      })
      .then(response => {                
          this.isChangePasswordConfirmModal = true;
          this.isUpdatePasswordModalVisible = false;
          this.cp_auth_code = '';
      })
      .catch(error => {
      });
    },





    countDownWarningChanged(dismissCountWarningDown) {
      this.dismissCountWarningDown = dismissCountWarningDown
    },
    countDownAuthChanged(dismissAuthCountDown) {
      this.dismissAuthCountDown = dismissAuthCountDown;
    },
    resendCode() {
      axios('/generate-myprofile-auth-code',
      {
          method: 'GET', 
      })
      .then(response => {                
          this.success_auth_message = 'Code resend successfully.';
          this.dismissAuthCountDown = 5;
      })
      .catch(error => {

      });
    },
    verifyCode() {
      if(this.auth_code == '') {
        alert("Please enter the verification code");
        return false;
      }
      else if(this.auth_code.length != 6) {
        alert("Verification code should be 6 digit");
        return false;
      }
      else {
        this.disable_verify_btn = true;
        axios('/verify-myprofile-auth-code',
        {
            method: 'POST',
            data: {
              code: this.auth_code,
            }
        })
        .then(response => {  
            this.isMultifactorAuthenticationConfirmModal = false;
            this.multifactor_authentication = true;
        })
        .catch(error => {
          this.warning_message = 'Invalid verification code.';
          this.dismissCountWarningDown = 5;
          this.auth_code = '';
        });
      }

    },
    closeAuthConfirm() {
      this.isMultifactorAuthenticationConfirmModal = false;
      this.multifactor_authentication = false;
      this.$emit('close');
    },
    openAuthModal(event) {
      if(event.target.checked == true) {

        axios('/generate-myprofile-auth-code',
        {
            method: 'GET', 
        })
        .then(response => {                
            this.isMultifactorAuthenticationConfirmModal = true;
            this.multifactor_authentication = false;
        })
        .catch(error => {
        });
      }
      else {
        axios('/update-myprofile-auth-code',
        {
            method: 'POST', 
        })
        .then(response => {                
            
        })
        .catch(error => {

        });
      }
    },
    checkIsEnterprise() {
      return checkIsEnterprise();
    },
    checkIsMentor() {
      return checkIsMentor();
    },
    checkIsManager() {
      return checkIsManager();
    },
    checkIsMentee() {
      return checkIsMentee();
    },
    truncate: function (text) {
      if (text.length > 35) {
          return text.substring(0, 35) + '...';
      } else {
          return text;
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    changeUserFrequency() {
      if(this.frequency != '') {
          this.buttonTitle = 'Update';
          this.modal_title = 'Are you sure you want to change the frequency of your Mentor Mentee support Communication?';
          this.modal_message = 'A successful mentoring program is based on consistent communication. <i>Mentor Mentee recommends your communication frequency remain on default.</i>';
          this.isPrefereceUpdateConfirmModalVisible = true;
      }
    },
    changeUserNewsSubscribe(event) {
      this.oldNewsSubscribe = this.news_subscription_checked;
      if(event.target.checked == true) {
        this.buttonTitle = 'Subscribe';
        this.modal_title = 'Confirm your subscription to news, updates, promotions, and more!';
        this.modal_message = '';
      }
      else {
        this.buttonTitle = 'Unsubscribe';
        this.modal_title = 'Confirm your unsubscribe to news, updates, promotions & more!';
        this.modal_message = 'You will still receive transactional & account-related support emails.';
      }
      this.isPrefereceUpdateConfirmModalVisible = true;
    },
    closeSuccessConfirm() {
      this.isSuccessConfirmModalVisible = false;
      this.preference_news_subscription_selected = '';
      this.$emit('close');
      this.navigate();
    },
    closeConfirm() {
      if((this.oldNewsSubscribe == 0) || (this.oldNewsSubscribe == 1)) {
        this.news_subscription_checked = this.oldNewsSubscribe;
        if(this.news_subscription_checked == 0) {
          this.news_subscription_selected = false;
        }
        else {
          this.news_subscription_selected = true;
        }
      }
      if(this.oldFrequency) {
        this.frequency = this.oldFrequency;  
      }
      this.isPrefereceUpdateConfirmModalVisible = false;
      this.$emit('close');
    },
    onFrequencySubmit() {
      axios('/account_lookup/frequency_update',
        {
        method: 'POST',
        data: {
            frequencyType: this.frequency,
            account_id: this.$store.state.user_accountid,
            user_id: this.userId,
        }
        },
      )
      .then(response => {
        this.modal_success_title = 'Mentoring Support Communication Updated';
        this.modal_success_message = 'Your communication preferences have been updated to ' + this.frequency + '.';
        this.isPrefereceUpdateConfirmModalVisible = false;
        this.isSuccessConfirmModalVisible = true;
      })
      .catch(error => {

      })
    },
    onSubscribeNewsSubmit() {
      axios('/account_lookup/news_subscription_update',
          {
          method: 'POST',
          data: {
              isSubscribeNews: this.news_subscription_selected,
              account_id: this.$store.state.user_accountid,
              user_id: this.userId,
          }
          },
      )
      .then(response => {
        if((this.news_subscription_selected == true)) {
          this.modal_success_title = 'Mentoring Support Communication Updated';
          this.modal_success_message = 'Subscribed to mentoring news, updates, promotions & more!';
          this.isPrefereceUpdateConfirmModalVisible = false;
          this.isSuccessConfirmModalVisible = true;
        }
        else if((this.news_subscription_selected == false)) {
          this.modal_success_title = 'Mentoring Support Communication Updated';
          this.modal_success_message = 'Unsubscribed to mentoring news, updates, promotions & more!';
          this.isPrefereceUpdateConfirmModalVisible = false;
          this.isSuccessConfirmModalVisible = true;
        }

      })
      .catch(error => {

      })
    },          
    openEditProfileForm() {
      this.isEditProfileModalVisible = true;
      this.$refs.edit_profile_form.getProfileUser();
    },
    openUpdatePasswordForm() {
      this.isUpdatePasswordModalVisible = true;
    },
    isUser() {
      if(this.$route.params.user_id) {
        return false;
      }
      else {
        return true;
      }
    },
    navigate(pathUrl) {
      router.go({
        path: pathUrl,
        force: true
      });
    },
    isInArray(value, array) {
      return array.indexOf(value) > -1;
    },
    rolesFormatter(value) {
      let formattedRoles = value.replace(new RegExp('ROLE_', 'g'),'');
      formattedRoles =  formattedRoles.replace(new RegExp('_', 'g'),' ');
      return formattedRoles.toLowerCase();
    },    
  },
  created: function() {
    var roles = this.$store.state.roles;
    if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
      this.masterAdmin = true;
    }
    if(roles.indexOf('ROLE_RESEARCHER') > -1) {
      this.researcher = true;
    }
    if(roles.indexOf('ROLE_CSR') > -1) {
      this.csr = true;
    }
    if(roles.indexOf('ROLE_ENTERPRISE_ADMIN') > -1) {
      this.entepriseAdmin = true;
    }
    if(
      ((roles.indexOf('ROLE_ADMIN') > -1)
      ||
      (this.$store.state.switch_admin_username))
      &&
      ((this.$store.state.switch_flag != 'Instructor')
      &&
      (this.$store.state.switch_flag != 'Mentor'))
      ) {
      this.admin = true;
    }

    this.loading = true;
    document.body.className = 'profile-page';
    var userAccountId = '';
    if(store.state.user_accountid) {
      userAccountId = store.state.user_accountid;
    }
    axios('/my-profile',
      {
        method: 'POST',
        data: {
               "accountId": userAccountId,
        }
      }
    )
    .then(resp => {
      this.loading = false;
      for(var i=0; i < resp.data.user.groups.length; i++) {
        this.groups.push(resp.data.user.groups[i].id);
      }
      this.userId = resp.data.user.userId;
      this.first_name = resp.data.user.first_name;
      this.last_name = resp.data.user.last_name;
      this.phone_number = resp.data.user.phone_number;
      this.email = resp.data.user.email;
      this.roles = resp.data.user.roles;
      this.is_mentee = resp.data.user.is_mentee;
      this.multifactor_authentication = resp.data.user.multifactor_authentication;

      this.news_subscription_selected = resp.data.isSubscribeNews;
      if(this.news_subscription_selected == true) {
        this.news_subscription_checked = 1;
      }
      this.frequency = resp.data.frequencyType;
      this.oldFrequency = resp.data.frequencyType;
      if((!this.frequency) && (resp.data.isDisableNotify) == false) {
        this.frequency = 'Daily';
        this.oldFrequency = 'Daily';
      }
    })
    .catch(error => {
      this.loading = false;
    })
  },
}
</script>

<style scoped>
.content-wrapper {
  padding-top: 75px;
}
.container-wrapper .heading {
  font-size: 28px;
  font-weight: normal;
}
a {
  color: #00acee;
}
a:hover,
a:active,
a:focus {
  color: #00acee;
}

.db-card {
  background-color: #FFF;
  border: 1px solid  #CCC;
  width: 99%;
  min-height: 10px;
  padding: 10px;
  margin: 0px 0 0px 0;
  border-radius: 10px;  

}
.db-card .db-mentee-name {
  font-weight: 600;
  word-break: break-word;
}
.db-card .db-mentor-name {
  word-break: break-word;
  font-weight: 900;
}
.db-card .db-mentor-name span{
  word-break: break-word;
  font-weight: normal;
}
.grid_row {
  margin-top: 0px;
}
/* .grid_row .cols { padding: 0; } */
.db-card .label_txt {
  font-weight: 400;
  margin-bottom: 5px;
}
.saveBtn, .saveBtn:active, .saveBtn:focus {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 120px;  
}
.container {
    max-width: 990px;
}
.dbViewBtn{
  color: #00acee !important;
  background-color: #FFF;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  width: 50px;
  float: right;
}
.dbViewBtn:focus, .dbViewBtn:active {
  color: #00acee !important;
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
} 
.user-icon{ font-size: 60px;  margin-bottom: 10px; }
.mentor_row { margin: 30px; }
.db-card .title{
  font-size: 15px;
  font-weight: 900;
}
.db-card .db-report-card {
  background-color: #FFF;
  border-radius: 0px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
.db-card .db-empty-card {
  background-color: #FFF;
  border-radius: 0px;
  min-height: 40px;
  padding: 10px;
  text-align: center;
}
a.dbEditBtn {
  border: 0px solid #29A3E4;
  background: none;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  text-decoration: underline !important;
  text-align: right;
}
a.dbEditBtn {
  width: 50px;
  float: right;
  margin-top: 0px;
}
.dbEditBtn:focus, .dbEditBtn:hover {
  background:none !important;
  border: 0px solid #00acee !important;
  box-shadow: none !important;
} 

.dbGoalBtn {
  text-decoration: underline;
  color: #7d7d7d !important;
}
.db-card .empty-content-title{
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.view-mentee-hr {
    margin-top: 5px;
    margin-bottom: 0px;
    border: 1px solid #00ACEE;
}
/* Small Devices */
@media (min-width: 320px) and (max-width: 991px) { 
    .statusBtn, .statusBtn:active, .statusBtn:focus {
        width: 100%;
    }
}



.dialogbox .body {
  position: relative;
  max-width: 300px;
  height: auto;
  margin: 20px 10px;
  padding: 5px;
  border-radius: 3px;
  border: 5px solid #ccc;
}

.body .message {
  min-height: 30px;
  border-radius: 3px;
  font-family: Arial;
  font-size: 14px;
  line-height: 1.5;
  color: #797979;
}
    .slide-leave-active,
    .slide-enter-active {
      transition: 0.4s;
    }
    .slide-enter {
      transform: translate(100%, 0);
    }
    .slide-leave-to {
      transform: translate(-100%, 0);
    }
.profile-page .main-wrapper {
   background-color: #FFF;
   padding: 10px;
   min-height: 400px;
   transform: none;
   margin-top:20px;
   width: 50%;
}
@media(max-width:768px) {
  .profile-page .main-wrapper {
     width: 70%;
   }
}
@media (max-width: 560px) {
 .profile-page .main-wrapper {
    border-radius: 5px;
    width: 100%;
  }
}
@media (max-width: 575.98px) {
  .col-xs-1 {
   width: 8.33333333%;
  }
  .col-xs-11 {
    width: 91.66666667%;
  }
  .col-xs-4 {
    width: 33.333333%;
  }
  .col-xs-8 {
    width: 66.666667%;
  }
  .col-xs-9 {
    width: 75%;
  }
  .col-xs-3 {
    width: 25%;
  }
}
.content-main-wrapper h3 {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  color: #555;
}
.marginbot10 {
  margin-bottom: 10px;
}
.profile-heading {
  margin-top: 10px;
}
label {
  font-size: 12px;
}
.profile-sec-sep {
  border-top: 1px solid #DDD;
  margin: 20px 0px 20px 0px;
}
#profile-link-wrapper .profile-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}
#edit-profile-wrapper label {
  padding-left: 0px;
}
.edit-profile-wrapper .submit{
  padding-right: 15px;
  margin-top: 10px;
}
.custom-chkbox {
  width: 10%;
  float: left;
}
label.group-chkbox {
  font-weight: normal;
}
.roles { text-transform: capitalize; }
.profile-container label{
  font-weight:bold;
}
.profile-container .chkboxwrapper label{
  font-weight:normal;
}

.edit-profile-wrapper {
  padding-top: 10px;
}
.question_text, .question_text a, .question_text a:hover {
  font-size: 11px;
  color: #002F42;
}
.color-blue a, .color-blue a:hover{
  color: #29A3E4 !important;
  text-decoration: underline;
  font-weight: bold;
}
.start-button {
    color: #29A3E4;
    background-color: #FFF !important;
    border: 1px solid #29A3E4 !important;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 110px;
}
.start-button-blue {
    color: #fff;
    background-color: #29A3E4 !important;
    border: 1px solid #29A3E4 !important;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 87px; 
}
.content-main-wrapper {
  width: 100%;
  background-color: #FFF;
  padding: 0px;
  margin-bottom: 0px;
}
.personal-details-wrapper {
  padding-left: 5%;
  padding-right: 5%;   
}
.custom-select {
    height: 25px;
    padding: 0;
    padding-left: 10px;
}
.preference-heading {
    font-size: 14px;
}
.ma-blue-btn1 {
  color: #FFF !important; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  border-radius: 10px;
  width: 120px;
}
.ma-white-btn1 {
  color: #00ACEE !important; 
  background-color: #FFF !important;
  border: 1px solid #00ACEE !important;
  font-weight: 900;
  border-radius: 10px;
  width: 120px;
}
body.profile-page {
    background: none;
}
.objective-view-icon {
  width: 15px;
  margin-left: 5px !important;
}
.db-card a {
    color: #00ACEE !important;
}
a {
    cursor: pointer;
}
.col-12 .border-bottom:last-child {
    border: 0 !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;

}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;

}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #808080;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 2px;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #FFF;
}

input:checked + .slider {
  background-color: #4E8D23;
}
input:checked + .slider:before {
  background-color: #FFF;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/* verify code css */
/deep/ .otp-single-input {
  width: 64px;
  height: 64px;
  font-size: 32px;
  border-radius: 7px;
  border: 1px solid #ced4da;
  font-weight: bold;
}
/deep/ .single-input-container {
  margin: 0px 6px;
}

/deep/ input.otp-single-input[type="number"] {
  -moz-appearance: textfield;
}

/deep/ input.otp-single-input[type="number"]::-webkit-outer-spin-button,
/deep/ input.otp-single-input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/deep/ input.otp-single-input[type="number"] {
  appearance: textfield;
}

</style>



// WEBPACK FOOTER //
// src/components/my_profile.vue